// extracted by mini-css-extract-plugin
module.exports = {"NavbarHolder":"BottomNavigation_NavbarHolder__16e_0","onFocus":"BottomNavigation_onFocus__2qYHD"};